export const FETCH_ALL_CASE_DATA = "FETCH_ALL_CASE_DATA";
export const FETCH_ALL_CASE_DATA_SUCCESS = "FETCH_ALL_CASE_DATA_SUCCESS";
export const FETCH_ALL_CASE_DATA_FAILED = "FETCH_ALL_CASE_DATA_FAILED";

export function fetchAllCaseData(payload) {
  return {
    type: FETCH_ALL_CASE_DATA,
    payload,
  };
}

export function fetchAllCaseDataSuccess(payload) {
  return {
    type: FETCH_ALL_CASE_DATA_SUCCESS,
    payload,
  };
}

export function fetchAllCaseDataFail(payload) {
  return {
    type: FETCH_ALL_CASE_DATA_FAILED,
    payload,
  };
}
